export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderSuggestions@2x.png";